export function parseCssDuration(value: string): number {
    if (value.endsWith('ms')) {
        return Number.parseInt(value, 10);
    }
    return Number.parseFloat(value) * 1000;
}
